import type {GuideLevelReports, ReportResults} from './CompareClasses.types';

// transform incoming data from the api into store format ReportInStore
export const transformReportResults = (reportResults: ReportResults = []) => {
  const reports: GuideLevelReports = {};

  if (!reportResults.length) {
    return {};
  }

  reportResults.forEach((result) => {
    if (!result || !result.guideLevel) {
      return;
    }

    const guideId = result.guideLevel.id;
    const classroom = result.secondaryClassroom;

    if (!reports[guideId]) {
      reports[guideId] = {
        id: guideId,
        classrooms: []
      };
    }

    if (classroom && classroom.name) {
      reports[guideId].classrooms.push({
        id: classroom.id,
        name: classroom.name,
        metrics: result.metrics
      });
    }
  });

  return reports;
};
